import { ReactNode, useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

import { OidcRedirectState } from '../hooks';

export type PropsAuthedRedirect = {
  renderLoadingUI?: () => ReactNode;
  onReceiveSigninState?: (signInState: OidcRedirectState | undefined) => void;
};
export function AuthedRedirect({
  onReceiveSigninState,
  renderLoadingUI = () => null,
}: PropsAuthedRedirect) {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated, error, user, signoutRedirect } =
    useAuth();

  useEffect(() => {
    (() => {
      if (isLoading) return;

      if (error) {
        console.error('Auth error:', error);
        return signoutRedirect({
          state: { refererPath: '/' } as OidcRedirectState,
        });
      }

      if (!isAuthenticated) {
        // Package has no reaction to current status, redirect to home page to prevent stuck in loading
        return navigate('/');
      }

      const state = user?.state as OidcRedirectState;
      if (typeof onReceiveSigninState === 'function') {
        onReceiveSigninState(state);
      }
      navigate(state?.refererPath ?? '/');
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  return renderLoadingUI();
}
